import { useEffect } from 'react';
import { useSearchParams, useRouter } from 'next/navigation';
import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';
import { runInAction } from 'mobx';
import { ContentSearchStore } from '../domain/stores/createContentSearchStore';
import { SearchResults } from './SearchResults';
import { SearchInputForm } from './SearchInputForm';
import { SearchNoResults } from './SearchNoResults';
import { SearchShimmer } from './SearchShimmer';
import { SearchEmptyState } from './SearchEmptyState';

interface IProps {
	store: ContentSearchStore;
}

export const SearchPageContent = observer(({ store }: IProps) => {
	const router = useRouter();
	const params = useSearchParams();
	const query = params.get('query') || '';
	const { loading, userQuery, content, pagination } = store;

	useEffect(() => {
		store.setUserQuery(query);
	}, [query]);

	const onSubmit = (newQuery: string) => {
		const url = `?query=${newQuery}`;
		router.push(url);
	};

	const onLoadMore = () => {
		runInAction(() => {
			store.bumpOffset();
		});
	};

	const renderContent = () => {
		if (!userQuery) return <SearchEmptyState />;

		if (loading) return <SearchShimmer />;

		if (content.length === 0) return <SearchNoResults />;

		return (
			<SearchResults
				results={content}
				pagination={pagination}
				onLoadMore={onLoadMore}
			/>
		);
	};

	return (
		<Wrapper>
			<SearchInputForm defaultQuery={query} onSubmit={onSubmit} />
			{renderContent()}
		</Wrapper>
	);
});

const Wrapper = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
`;
